import DisableWindowScroll from 'components/DisableWindowScroll/DisableWindowScroll.component';
import React, { CSSProperties } from 'react';
import Transition, {
  ENTERED,
  ENTERING,
  EXITED,
  EXITING,
  UNMOUNTED,
} from 'react-transition-group/Transition';
import { useTheme } from 'styled-components';
import { DrawerProps } from './Drawer.type';
import { ContentWrapperSlider, DrawerOverlay } from './style/Drawer.style';

const Drawer: React.FC<DrawerProps> = function Drawer({
  open,
  children,
  position = 'left',
  onClickOutside,
  overlayProps,
  sliderProps,
  enableOverlayUI = false,
}) {
  const {
    drawer: { transitionDurationMs },
  } = useTheme();

  return (
    <Transition in={open} timeout={transitionDurationMs}>
      {(status) => {
        const overlayStyle: CSSProperties = {
          opacity: 0,
          visibility: 'unset',
          pointerEvents: 'none',
        };
        const sliderStyle: CSSProperties = {
          pointerEvents: 'none',
          visibility: 'unset',
          boxShadow: 'none',
        };
        switch (status) {
          case EXITING:
            overlayStyle.opacity = 0;
            sliderStyle.visibility = 'unset';
            sliderStyle.boxShadow = 'none';
            overlayStyle.visibility = 'unset';
            sliderStyle.pointerEvents = 'none';
            overlayStyle.pointerEvents = 'none';
            break;
          case ENTERING:
            overlayStyle.opacity = 1;
            sliderStyle.visibility = 'unset';
            sliderStyle.boxShadow = 'none';
            overlayStyle.visibility = 'unset';
            overlayStyle.pointerEvents = 'none';
            sliderStyle.pointerEvents = 'none';
            break;
          case EXITED:
            overlayStyle.opacity = 0;
            sliderStyle.visibility = 'hidden';
            sliderStyle.boxShadow = 'none';
            overlayStyle.visibility = 'hidden';
            overlayStyle.pointerEvents = 'none';
            sliderStyle.pointerEvents = 'none';
            break;
          case UNMOUNTED:
            overlayStyle.opacity = 0;
            sliderStyle.visibility = 'hidden';
            sliderStyle.boxShadow = 'none';
            overlayStyle.visibility = 'hidden';
            overlayStyle.pointerEvents = 'none';
            sliderStyle.pointerEvents = 'none';
            break;
          case ENTERED:
            overlayStyle.opacity = 1;
            sliderStyle.visibility = 'unset';
            overlayStyle.visibility = 'unset';
            sliderStyle.boxShadow = '0 2px 8px 0 rgba(204,204,204,0.5)';
            overlayStyle.pointerEvents = 'auto';
            sliderStyle.pointerEvents = 'auto';
            break;
        }

        if (!enableOverlayUI) {
          overlayStyle.transition = 'none';
          overlayStyle.opacity = 0;
        }
        return (
          <>
            <DrawerOverlay
              {...overlayProps}
              style={overlayStyle}
              tabIndex={0}
              onClick={onClickOutside}
            />
            <ContentWrapperSlider
              {...sliderProps}
              style={sliderStyle}
              position={position}
              transitionStatus={status}
            >
              {children}
            </ContentWrapperSlider>
            {open && <DisableWindowScroll />}
          </>
        );
      }}
    </Transition>
  );
};

export default Drawer;
